import React from 'react';
import {
  Box,
  Heading,
  Text,
  VStack,
  Container,
  Icon,
} from '@chakra-ui/react';
import { Flag } from '@phosphor-icons/react';

const RequestCreditPage = () => {
  return (
    <Container maxW="container.md" py={10}>
      <VStack spacing={8} align="stretch">
        <Box>
          <Heading>Request Image Credit</Heading>
          <Text mt={4}>
            To request credit for an image, please find the image on our site, open it in the preview modal, and click the <Icon as={Flag} /> icon.
          </Text>
          <Text mt={2}>
            From there, you can select "Request Credit" and provide the necessary information. This ensures that we can identify the exact image you are referring to and process your request promptly.
          </Text>
        </Box>
      </VStack>
    </Container>
  );
};

export default RequestCreditPage;
